module.exports = __webpack_public_path__ + "static/text-to-speech-031ce228ea98e2da452aa52d3d95a721.png";